import Vue from 'vue'
import VueRouter from 'vue-router'
import Register from './pages/Register.vue'
import Login from './pages/Login.vue'
import EmailLogin from './pages/EmailLogin.vue'
import Success from './pages/Success.vue'
import EmailConfirmSuccess from './pages/EmailConfirmSuccess.vue'
import EmailBinding from './pages/EmailBinding.vue'
import EmailProviderBinding from './pages/EmailProviderBinding.vue'
import ResetPassword from './pages/ResetPassword.vue'
import ResetPasswordSuccess from './pages/ResetPasswordSuccess.vue'
import ResetPasswordExpired from './pages/ResetPasswordExpired.vue'
import Incident from './pages/Incident.vue'
import Hybrid from './pages/Hybrid.vue'
import ForgotPassword from './pages/ForgotPassword.vue'
import ForgotPasswordSent from './pages/ForgotPasswordSent.vue'
import Profile from './pages/Profile.vue'
import Consent from './pages/Consent.vue'
import Ineligible from './pages/Ineligible.vue'
import Delete from './pages/Delete.vue'
import InternalError from './pages/InternalError.vue'
import EkycWaiting from './pages/EkycWaiting.vue'
import store from '@/store/index'
import { REGISTER_MODULE, CLEAR_REGISTER_STATE } from './store/modules/register/constant'
import { FALLBACK_ROUTE } from './store/modules/app/constant'

Vue.use(VueRouter)

const Router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/email-login',
      name: 'email-login',
      component: EmailLogin
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/consent',
      name: 'consent',
      component: Consent
    },
    {
      path: '/ineligible',
      name: 'ineligible',
      component: Ineligible
    },
    {
      path: '/incident',
      name: 'incident',
      component: Incident
    },
    {
      path: '/hybrid',
      name: 'hybrid',
      component: Hybrid
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword
    },
    {
      path: '/reset-password-success',
      name: 'reset-password-success',
      component: ResetPasswordSuccess
    },
    {
      path: '/reset-password-expired',
      name: 'reset-password-expired',
      component: ResetPasswordExpired
    },
    {
      path: '/email-binding',
      name: 'email-binding',
      component: EmailBinding
    },
    {
      path: '/provider-binding',
      name: 'provider-binding',
      component: EmailProviderBinding
    },
    {
      path: '/email-confirm-success',
      name: 'email-confirm-sucess',
      component: EmailConfirmSuccess
    },
    {
      path: '/email-confirmation',
      name: 'email-confirmation',
      component: Success
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/forgot-password-sent',
      name: 'forgot-password-sent',
      component: ForgotPasswordSent
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/privacy/data-deletion',
      name: 'delete',
      component: Delete
    },
    {
      path: '/kyc-waiting',
      name: 'kyc-waiting',
      component: EkycWaiting
    },
    {
      path: '/pin/reset',
      name: 'pin-reset',
      component: () => import(/* webpackChunkName: "pin" */ './pages/ResetPin.vue')
    },
    {
      path: '*',
      name: 'internal-error',
      component: InternalError
    }
  ]
})

Router.beforeEach((to, from, next) => {
  if (!from.name) {
    const currentRoute = to.name as string
    if (currentRoute === 'login' || currentRoute === 'register') {
      localStorage.setItem(FALLBACK_ROUTE, currentRoute)
    }
  }
  if (to.name !== 'email-login') {
    store.dispatch(`${REGISTER_MODULE}/${CLEAR_REGISTER_STATE}`)
  }
  if (from.query.challenge && !to.query.challenge) {
    if (to.path === from.path) {
      return // This is a no-no via the documentation, but a bug in routing to identical routes strips query params, and this prevents that
    }
    next({ path: to.path, query: { ...to.query, ...{ challenge: from.query.challenge } } })
  }

  next()
})

export default Router
